import React, { useState } from 'react';
import { Box, Button, VStack, Heading, Span } from '@bpba/ui-components';
import { useMutation } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { ProvinciaIntegraModel } from '../rest/models/ProvinciaIntegraModel';
import { ProvinciaIntegraRQ } from '../rest/models/ProvinciaIntegraRQ';
import { postProvinciaIntegra } from '../rest/mutations/postProvinciaIntegra';


const validateRealCuit = (cuit: string) => {
    let rv = false;

    let resultado = 0;
    const codes = "6789456789";
    let verificador = parseInt(cuit[cuit.length - 1]);
    let x = 0;

    while (x < 10) {
        let digitoValidador = parseInt(codes.substring(x, x + 1));
        if (isNaN(digitoValidador)) digitoValidador = 0;
        let digito = parseInt(cuit.substring(x, x + 1));
        if (isNaN(digito)) digito = 0;
        let digitoValidacion = digitoValidador * digito;
        resultado += digitoValidacion;
        x++;
    }
    resultado = resultado % 11;
    rv = resultado === verificador;

    return rv ? rv : "Verifique el Cuit ingresado";
};



const ProvinciaIntegraComponente: React.FC = () => {


    const { register, handleSubmit, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
        }
    });

    const REQUIRED_FIELD = "Campo requerido.";
    //eslint-disable-next-line
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [errorServicio] = useState<boolean>(false);
    const [mensajeError] = useState<string>("");
    const [mensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [postProvinciaIntegraAPI, { loading: loadingMutation }] = useMutation<Mutations>(postProvinciaIntegra);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");

    const onSubmit: SubmitHandler<ProvinciaIntegraModel> = async (data: ProvinciaIntegraModel) => {

        const token = executeRecaptcha && (await executeRecaptcha('ProvinciaIntegra'));
        let datos: ProvinciaIntegraRQ = {
            "googleToken": token,
            "cuit": data.cuit,
            "razonSocial": data.razonSocial,
            "telefonoContacto": data.telefono + data.telefonoArea,
            "nombreContacto": data.nombre,
            "email": data.email,
            "necesidad": data.detalle,
            "origenSolicitud": "web",
            "sucursal": 0,
            "localidad": "-",
            "condicionImpositiva": "1",
        };

        await postProvinciaIntegraAPI({ variables: { input: datos } }).then((response: any) => {

            if (response !== null || response !== undefined) {

                setServicioOk(true);
                if (response.data.ProvinciaIntegraRS.resultado === "ok") {

                    setMensajeRtaServicio("Solicitud creada con éxito.En los próximos días nos contactaremos con vos.");

                } else if (response.data.ProvinciaIntegraRS.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())) {

                    setMensajeRtaServicio(response.data.ProvinciaIntegraRS.error);

                } else {
                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                }
            } else {

                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        }).catch(() => {

            setServicioOk(true);
            setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
        });
    }




    if (loadingMutation) return <SpinnerCajas />;
    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    if (servicioOk) return (

        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>

    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );



    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    {errorServicio ?
                        <VStack mt={"20px"}>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {mensajeError}
                            </Span>
                        </VStack> : <></>
                    }

                    <VStack mt={"20px"}>
                        <input {...register(`razonSocial`, { required: REQUIRED_FIELD, maxLength: 100 })} name='razonSocial' type={"text"} defaultValue={""} placeholder='Nombre o denominación de la empresa/organización' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <input type={"text"} tabIndex={0}
                            {...register("cuit", {
                                required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                maxLength: 11, validate: (value) => validateRealCuit(value.toString())
                            })}
                            name='cuit' id='cuit' placeholder='CUIT de la empresa/organización' maxLength={11} minLength={11} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                            {errors.cuit ? "* " + errors.cuit.message : ""}
                        </Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <input {...register(`nombre`, { required: REQUIRED_FIELD, maxLength: 100 })} name='nombre' type={"text"} defaultValue={""} placeholder='Nombre y Apellido' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombre ? "* " + errors.nombre.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Teléfono de contacto
                        </Span>
                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                            </VStack>
                        </VStack>
                    </VStack>
                    <VStack mt={"20px"}>
                        <Span color="primary.0" marginBottom={"8px"} fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Detalle
                        </Span>


                        <VStack>
                            <textarea style={{ border: "none", borderBottom: "1px solid black", outlineColor: "#25b4b", minHeight: "calc(1.5em + 0.75rem + 2px)", color: "#49505", fontFamily: "Encode Sans, sans-serif", padding: "0.375rem 1.75rem 0.375rem 0.75rem", lineHeight: "18px" }}
                                {...register(`detalle`, { required: REQUIRED_FIELD, maxLength: 2000 })} name='detalle' placeholder='Describa en detalle la necesidad o problemática que busca resolver mediante los servicios del Banco' maxLength={2000} />
                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.detalle ? "* " + errors.detalle.message : ""}</Span>
                        </VStack>
                    </VStack>

                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>


                </form>
            </VStack>

        </Box>

    )

};



export default ProvinciaIntegraComponente;
